<template>
    <div style="height:400px;border-radius:8px" class="card pt-0 mb-3 bg-white px-3 py-3">
        <div class="row">
            <div class="col-7 text-left">
                <h4 class="card-title pl-3 pb-2 mb-0">{{nama}}</h4>
            </div>
            <div class="col-5 text-right">
                <h4 v-if="userExp != ''" class="card-title pl-3 pb-2 mb-0">{{exp}}</h4>
            </div>
        </div>
        <div class="row no-gutters">
            <div class="col-md-1">
                <hr class="border-primary"/>
            </div>
            <div class="col-md-11">
                <hr/>
            </div>
        </div>
        <div id="chart">
            <apexchart type="donut" height="300" v-if="status == true" :options="chartOptions" :series="series"></apexchart>
        </div>
    </div>
</template>

<script>
export default {
    props: ['userNama', 'userSisa', 'userExp', 'userAktif', 'userTidakAktif'],
    
    data() {
        return {
            nama: '',
            exp: '',
            status: false,
            series: [],
            chartOptions: {
                chart: {
                    id: 'diagram',
                    width: 300,
                    type: 'donut',
                    dropShadow: {
                        enabled: true,
                        color: '#111',
                        top: -1,
                        left: 3,
                        blur: 3,
                        opacity: 0.2
                    }
                },
                stroke: {
                    width: 0,
                },
                plotOptions: {
                pie: {
                    donut: {
                    labels: {
                        show: true,
                        total: {
                            showAlways: true,
                            show: true,
                            formatter: function (w) {
                                let vals = w.globals.seriesTotals
                                var i = 0
                                let totals = 0
                                for(i=0;i<vals.length;i++) {
                                    totals += vals[i]
                                }
                                let val = totals.toString()
                                let leng = val.length
                                let sisa 	= leng % 3
                                let rupiah 	= val.substr(0, sisa)
                                let ribuan 	= val.substr(sisa).match(/\d{3}/g)
                                    
                                if (ribuan) {
                                    let separator = sisa ? '.' : ''
                                    rupiah += separator + ribuan.join('.')
                                }
                                return rupiah
                            }
                        },
                        name: {
                            show: true,
                            formatter: function (val) {
                                return val
                            }
                        },
                        value: {
                            show: true,
                            formatter: function (val) {
                                let value = val.toString()
                                let leng = value.length
                                let sisa 	= leng % 3
                                let rupiah 	= value.substr(0, sisa)
                                let ribuan 	= value.substr(sisa).match(/\d{3}/g)
                                    
                                if (ribuan) {
                                    let separator = sisa ? '.' : ''
                                    rupiah += separator + ribuan.join('.')
                                }
                                return rupiah
                            }
                        },
                    }
                    }
                }
                },
                labels: ['Jumlah Aktif', 'Jumlah Tidak Aktif', 'Jumlah yang belum digunakan'],
                dataLabels: {
                    dropShadow: {
                        blur: 3,
                        opacity: 0.8
                    }
                },
                states: {
                    hover: {
                        filter: 'none'
                    }
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },
        }
    },
    watch: {
        userNama(baru, lama) {
            this.status = false
            this.nama = baru
            this.exp = this.userExp
            let aktif = parseInt(this.userAktif)
            let tidakAktif = parseInt(this.userTidakAktif)
            let sisa = parseInt(this.userSisa)
            if(aktif < 0) {
                aktif = 0
            }
            if(tidakAktif < 0) {
                tidakAktif = 0
            }
            if(sisa < 0) {
                sisa = 0
            }
            this.series[0] = aktif
            this.series[1] = tidakAktif
            this.series[2] = sisa
            this.status = true
        },
    },
    methods: {
    },
    mounted() {
    },
}
</script>
<style scoped>
.card-title {
    font-size: 14px;
    color: rgba(0, 0, 0, 1);
    height: 100%;
}
</style>